export default __webpack_public_path__ + "static/media/img09.a071afa9.webp";